// assets/configurator-cart.js
// ======================================================
// 1) Preisgruppe an Konfigurator übergeben (VK01 fix)
// ======================================================
function getAuthenticationData(callback) {
  var groupId = "VK01";
  callback({ customerGroupNumber: groupId });
}

// ======================================================
// 2) Mapping: EAN -> Shopify Variant-ID (Felgen)
// ======================================================
var VARIANT_BY_EAN = {
  "4250683523389": 51880542929238,
  "4250683523365": 51816865202518,
  "4250683523433": 51816865562966,
  "4250683523419": 51816865530198,
  "4250683523396": 51816864809302,
  "4250683523372": 51816864776534,
  "4250683523426": 51816865890646,
  "4250683523402": 51816865923414,
  "4250683524898": 55392013386070,
  "4250683524904": 55392013418838
};

// ======================================================
// 3) Globale Variablen aus theme.liquid
//    - window.VEHICLE_CONFIG_VARIANT_ID
//    - window.MOUNTING_KIT_VARIANT_BY_CODE
// ======================================================
var VEHICLE_CONFIG_VARIANT_ID =
  typeof window !== "undefined" && window.VEHICLE_CONFIG_VARIANT_ID
    ? window.VEHICLE_CONFIG_VARIANT_ID
    : null;

var MOUNTING_KIT_VARIANT_BY_CODE =
  typeof window !== "undefined" && window.MOUNTING_KIT_VARIANT_BY_CODE
    ? window.MOUNTING_KIT_VARIANT_BY_CODE
    : {};

// ======================================================
// 3a) Sechskant-Tool-Variante dynamisch über /products/tool.js laden
// ======================================================
var HEX_TOOL_VARIANT_ID = null;

(function preloadHexToolVariant() {
  try {
    fetch("/products/tool.js", { credentials: "same-origin" })
      .then(function (res) {
        if (!res.ok) throw new Error("HTTP " + res.status);
        return res.json();
      })
      .then(function (product) {
        if (
          product &&
          product.variants &&
          Array.isArray(product.variants) &&
          product.variants.length > 0
        ) {
          HEX_TOOL_VARIANT_ID = product.variants[0].id;
          window.HEX_TOOL_VARIANT_ID = HEX_TOOL_VARIANT_ID;
          console.log(
            "Hex-Tool Variant via /products/tool.js geladen:",
            HEX_TOOL_VARIANT_ID
          );
        } else {
          console.warn(
            "Hex-Tool Produkt /products/tool.js hat keine Varianten oder unerwartete Struktur:",
            product
          );
        }
      })
      .catch(function (err) {
        console.error("Fehler beim Laden von /products/tool.js:", err);
      });
  } catch (e) {
    console.error("Exception beim Preload des Hex-Tools:", e);
  }
})();

// ======================================================
// 3b) Montageboxen MB20–MB22 bei Bedarf per .js nachladen
//     (wegen all_products-Limit von 20 Produkten)
// ======================================================
var MOUNTING_KIT_HANDLE_BY_CODE = {
  MB20: "montagebox-20",
  MB21: "montagebox-21",
  MB22: "montagebox-22"
};

function loadMountingKitVariantId(code, mapping) {
  // 1) Wenn im Mapping eine ID steht, direkt nutzen
  if (mapping && mapping[code]) {
    return Promise.resolve(mapping[code]);
  }

  // 2) Für MB20–MB22 per /products/{handle}.js nachladen
  var handle = MOUNTING_KIT_HANDLE_BY_CODE[code];
  if (!handle) {
    return Promise.resolve(null);
  }

  console.log("Lade Montagebox-Variante per .js für Code:", code, "Handle:", handle);

  return fetch("/products/" + handle + ".js", { credentials: "same-origin" })
    .then(function (res) {
      if (!res.ok) throw new Error("HTTP " + res.status);
      return res.json();
    })
    .then(function (product) {
      if (
        product &&
        product.variants &&
        Array.isArray(product.variants) &&
        product.variants.length > 0
      ) {
        var vid = product.variants[0].id;
        console.log("Geladene Variant-ID für", code, ":", vid);
        return vid;
      }
      console.warn(
        "Produkt für",
        code,
        "hat keine Varianten oder unerwartete Struktur:",
        product
      );
      return null;
    })
    .catch(function (err) {
      console.error("Fehler beim Laden der Montagebox " + code + ":", err);
      return null;
    });
}

// ======================================================
// 4) Felgeninfos für Properties (aktuell nur EAN)
// ======================================================
function extractRimData(data) {
  var rimData =
    (data && data.rims && (data.rims.SelectedRim || data.rims.frontAxis)) ||
    {};

  return {
    // Farbe aktuell nicht mehr als Property genutzt
    farbe: rimData.ManufacturerColor || "Unbekannt"
  };
}

// ======================================================
// 5) Fahrzeug-Text für Dummy-Produkt bauen
// ======================================================
function buildVehicleText(data) {
  if (!data) return null;

  var v =
    data.vehicle ||
    data.car ||
    data.selectedVehicle ||
    data.vehicleInfo ||
    null;

  if (!v) return null;

  var manufacturer = v.Manufacturer || v.manufacturer || v.Make || v.make || "";
  var model = v.Model || v.model || "";
  var type = v.Type || v.type || v.Series || v.series || "";
  var engine = v.Engine || v.engine || v.Motor || v.motor || "";
  var year = v.Year || v.year || "";
  var kba =
    v.KBA ||
    v.kba ||
    v.HSNTSN ||
    v.hsnTsn ||
    (v.HSN && v.TSN ? v.HSN + "/" + v.TSN : "") ||
    "";

  var parts = [];
  if (manufacturer) parts.push(manufacturer);
  if (model) parts.push(model);
  if (type) parts.push(type);
  if (engine) parts.push(engine);
  if (year) parts.push(year);

  var main = parts.join(" ");
  var extras = [];
  if (kba) extras.push("KBA/HSN-TSN: " + kba);
  if (v.Body || v.body) extras.push("Karosserie: " + (v.Body || v.body));

  var text = main;
  if (extras.length) text += " (" + extras.join(", ") + ")";

  return text || null;
}

// ======================================================
// 6) Montagekit aus payload ziehen (MB1..MB22 etc.)
// ======================================================
function extractMountingKit(data) {
  if (!data || !data.mountingKits) return null;

  var mk = data.mountingKits;
  var front = mk.frontAxis || {};
  var rear = mk.rearAxis || {};

  var code =
    front.manufacturerOrderNumber ||
    front.ManufacturerOrderNumber ||
    rear.manufacturerOrderNumber ||
    rear.ManufacturerOrderNumber ||
    null;

  var qtyFront = parseInt(front.quantity || 0, 10) || 0;
  var qtyRear = parseInt(rear.quantity || 0, 10) || 0;
  var qty = qtyFront + qtyRear;

  if (!code) return null;

  return {
    code: String(code).trim(),
    payloadQuantity: qty
  };
}

// ======================================================
// 7) Helper: mehrere LineItems auf einmal zu Shopify-Cart hinzufügen
// ======================================================
function addItemsToCart(items) {
  console.log("Sende Sammel-Request an /cart/add.js:", items);

  return fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "same-origin",
    body: JSON.stringify({ items: items })
  }).then(function (res) {
    return res.text().then(function (text) {
      console.log("Rohantwort /cart/add.js:", res.status, text);

      if (!res.ok) {
        console.error("Antwort von /cart/add.js (Fehler):", text);
        throw new Error("Cart Error: " + text);
      }

      try {
        return JSON.parse(text);
      } catch (e) {
        return text;
      }
    });
  });
}

// ======================================================
// 8) Notify-Funktion des 3PC-Konfigurators
// ======================================================
window.myNotifyFunction = async function (eventType, hash, data) {
  if (eventType !== "shoppingBasket") return;

  try {
    console.log("=== 3PC shoppingBasket EVENT ===");
    console.log("eventType:", eventType, "hash:", hash);
    console.log("RAW data object:", data);

    console.log("data (pretty JSON):", JSON.stringify(data, null, 2));

    var vehicleConfigVariantId = VEHICLE_CONFIG_VARIANT_ID || null;
    var kitMapping = MOUNTING_KIT_VARIANT_BY_CODE || {};
    var hexToolVariantId =
      HEX_TOOL_VARIANT_ID || window.HEX_TOOL_VARIANT_ID || null;

    console.log("Resolved vehicleConfigVariantId:", vehicleConfigVariantId);
    console.log("Resolved kitMapping keys:", Object.keys(kitMapping));
    console.log("Resolved hexToolVariantId:", hexToolVariantId);

    // ----- 8.1 EAN ermitteln -----
    var ean = null;
    if (data && data.rims) {
      if (data.rims.frontAxis && data.rims.frontAxis.EAN) {
        ean = data.rims.frontAxis.EAN;
      } else if (
        data.rims.SelectedRimFront &&
        (data.rims.SelectedRimFront.EanCode ||
          data.rims.SelectedRimFront.EAN)
      ) {
        ean =
          data.rims.SelectedRimFront.EanCode ||
          data.rims.SelectedRimFront.EAN;
      } else if (data.rims.SelectedRim && data.rims.SelectedRim.EAN) {
        ean = data.rims.SelectedRim.EAN;
      }
    }

    if (!ean) {
      alert("Kein EAN-Code vom Konfigurator erhalten.");
      console.error("EAN fehlt in data.rims:", data && data.rims);
      return;
    }

    var eanStr = String(ean).trim();
    console.log("Ermittelte EAN:", eanStr);

    var variantId = VARIANT_BY_EAN[eanStr];
    console.log("Variant-ID aus VARIANT_BY_EAN für", eanStr, ":", variantId);

    if (!variantId) {
      alert("Für die EAN " + eanStr + " ist keine Variante im Shop hinterlegt.");
      console.error(
        "Keine Variant-ID im Mapping für EAN",
        eanStr,
        VARIANT_BY_EAN
      );
      return;
    }

    // ----- 8.2 Felgen-Menge bestimmen -----
    var qtyFront =
      (data &&
        data.rims &&
        data.rims.frontAxis &&
        parseInt(data.rims.frontAxis.quantity || 0, 10)) ||
      0;
    var qtyRear =
      (data &&
        data.rims &&
        data.rims.rearAxis &&
        parseInt(data.rims.rearAxis.quantity || 0, 10)) ||
      0;
    var quantity = qtyFront + qtyRear || 4;

    console.log("Mengenberechnung:", {
      qtyFront: qtyFront,
      qtyRear: qtyRear,
      quantity: quantity
    });

    // ----- 8.3 Properties für Felgen -----
    var rimInfo = extractRimData(data);
    console.log("RimInfo (für Properties):", rimInfo);

    var items = [];

    var rimLine = {
      id: variantId,
      quantity: quantity,
      properties: {
        EAN: eanStr
        // Farbe aktuell bewusst weggelassen
      }
    };
    console.log("Felgen-LineItem:", rimLine);
    items.push(rimLine);

    // ----- 8.4 Montagekit (1 Satz pro 4 Felgen) -----
    var kit = extractMountingKit(data);
    if (kit) {
      console.log("Montagekit aus payload:", kit);

      var kitVariantId = await loadMountingKitVariantId(kit.code, kitMapping);
      console.log("Ermittelte kitVariantId für", kit.code, ":", kitVariantId);

      if (kitVariantId) {
        var kitQuantity = Math.max(1, Math.ceil(quantity / 4));

        var mountingKitLine = {
          id: kitVariantId,
          quantity: kitQuantity,
          properties: {
            MontagekitCode: kit.code
          }
        };
        console.log("Montagekit-LineItem:", mountingKitLine);
        items.push(mountingKitLine);
      } else {
        console.warn(
          "Kein Mapping / keine Variant-ID für Kit-Code",
          kit.code
        );
      }
    } else {
      console.log("Kein Montagekit in payload gefunden.");
    }

    // ----- 8.4b Sechskant-Tool bei >=4 Felgen automatisch hinzufügen -----
    if (quantity >= 4) {
      if (hexToolVariantId) {
        var hexToolLine = {
          id: hexToolVariantId,
          quantity: 1,
          properties: {
            Hinweis: "Sechskant-Tool für CS1/CS2"
          }
        };
        console.log("Sechskant-Tool-LineItem:", hexToolLine);
        items.push(hexToolLine);
      } else {
        console.warn(
          "Sechskant-Tool NICHT hinzugefügt. hexToolVariantId:",
          hexToolVariantId,
          "Felgenmenge:",
          quantity
        );
      }
    } else {
      console.log(
        "Weniger als 4 Felgen, Sechskant-Tool wird nicht automatisch hinzugefügt. Menge:",
        quantity
      );
    }

    // ----- 8.5 Fahrzeug-Dummy vorbereiten (falls vorhanden) -----
    console.log(
      "vehicleConfigVariantId in myNotifyFunction:",
      vehicleConfigVariantId
    );
    if (vehicleConfigVariantId) {
      var vehicleText = buildVehicleText(data);
      console.log("Fahrzeug-Text für Dummy:", vehicleText);

      if (vehicleText) {
        var vehicleLine = {
          id: vehicleConfigVariantId,
          quantity: 1,
          properties: {
            Fahrzeugkonfiguration: vehicleText
          }
        };
        console.log("Fahrzeugkonfiguration-LineItem:", vehicleLine);
        items.push(vehicleLine);
      }
    } else {
      console.log(
        "vehicleConfigVariantId ist nicht gesetzt – Dummy-Produkt wird nicht hinzugefügt."
      );
    }

    // ----- 8.6 Alles in einem Request an /cart/add.js schicken -----
    addItemsToCart(items)
      .then(function () {
        console.log(
          "Alle LineItems erfolgreich an den Warenkorb gesendet, leite zu /cart weiter."
        );
        window.location.href = "/cart";
      })
      .catch(function (err) {
        console.error("Fehler beim Warenkorb-Request:", err);
        alert(
          "Es ist ein Fehler beim Hinzufügen zum Warenkorb aufgetreten:\n" +
            err.message
        );
      });
  } catch (e) {
    console.error("myNotifyFunction Exception:", e);
    alert("Unerwarteter Fehler in der Warenkorbintegration.");
  }
};